import { useState } from "react";
import { trpc } from "../../lib/trpc.js";
import { Botao, Campo, Entrada, Selo } from "../../components/ui.js";
import { useAuth } from "../auth/useAuth.js";

/**
 * Teste de envio, no topo da seção de e-mail.
 *
 * Presença de chave não prova nada: token errado, domínio não verificado e
 * caixa de teste inexistente só aparecem no primeiro envio. Sem este botão, o
 * primeiro envio seria um recibo de compra falhando em silêncio.
 */
export function PainelEmail() {
  const { usuario } = useAuth();
  const [para, setPara] = useState(usuario?.email ?? "");

  const status = trpc.config.integrationStatus.useQuery();
  const testar = trpc.config.testarEmail.useMutation();

  const emTeste = status.data?.emailEmTeste ?? true;
  const resultado = testar.data;

  return (
    <div className="mb-6 rounded-peca border border-borda bg-superficie p-4">
      <div className="mb-3 flex flex-wrap items-center gap-2">
        <Selo tom={status.data?.email ? "fixado" : "quieto"}>
          {status.data?.email ? "configurado" : "faltam dados"}
        </Selo>
        {/* O modo importa mais que o status: é ele que diz onde a mensagem
            cai, e evita a busca na caixa errada. */}
        <Selo tom={emTeste ? "projecao" : "brasa"}>{emTeste ? "modo de teste" : "envio real"}</Selo>
      </div>

      <p className="mb-4 text-[0.8125rem] leading-relaxed text-texto-suave">
        {emTeste
          ? "Nada sai para endereços reais: tudo cai na caixa de teste do Mailtrap. Desligue só quando for enviar a clientes."
          : "As mensagens vão para os endereços reais das pessoas."}
      </p>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
        <div className="flex-1">
          <Campo rotulo="Enviar teste para">
            <Entrada
              type="email"
              value={para}
              onChange={(e) => setPara(e.target.value)}
              autoCapitalize="none"
              autoCorrect="off"
            />
          </Campo>
        </div>
        <Botao
          tom="quieto"
          disabled={!para.includes("@")}
          carregando={testar.isPending}
          onClick={() => testar.mutate({ para })}
        >
          Enviar teste
        </Botao>
      </div>

      {resultado && (
        <p
          className={`mt-3 text-[0.8125rem] leading-relaxed ${
            resultado.enviado ? "text-fixado" : "text-descartar"
          }`}
        >
          {resultado.enviado
            ? resultado.emTeste
              ? "Enviado. A mensagem está na sua caixa de teste do Mailtrap, não no endereço acima."
              : "Enviado para o endereço acima."
            : resultado.erro}
        </p>
      )}
    </div>
  );
}
